export const patterns = {

    background: {
        name: "Banner Background",
        bannerImage: "/patterns/banner/base.png",
        shieldImage: "/patterns/shield/base.png",
        isBackground: true
    },
    shield: {
        name: "Shield Base",
        shieldImage: "/patterns/shield/shield_base.png",
        isBackground: true
    },
    bs: {
        name: "Base",
        bannerImage: "/patterns/banner/stripe_bottom.png",
        shieldImage: "/patterns/shield/stripe_bottom.png"
    },
    ts: {
        name: "Chief",
        bannerImage: "/patterns/banner/stripe_top.png",
        shieldImage: "/patterns/shield/stripe_top.png"
    },
    ls: {
        name: "Pale Dexter",
        bannerImage: "/patterns/banner/stripe_left.png",
        shieldImage: "/patterns/shield/stripe_left.png"
    },
    rs: {
        name: "Pale Sinister",
        bannerImage: "/patterns/banner/stripe_right.png",
        shieldImage: "/patterns/shield/stripe_right.png"
    },
    cs: {
        name: "Pale",
        bannerImage: "/patterns/banner/stripe_center.png",
        shieldImage: "/patterns/shield/stripe_center.png"
    },
    ms: {
        name: "Fess",
        bannerImage: "/patterns/banner/stripe_middle.png",
        shieldImage: "/patterns/shield/stripe_middle.png"
    },
    drs: {
        name: "Bend",
        bannerImage: "/patterns/banner/stripe_downright.png",
        shieldImage: "/patterns/shield/stripe_downright.png"
    },
    dls: {
        name: "Bend Sinister",
        bannerImage: "/patterns/banner/stripe_downleft.png",
        shieldImage: "/patterns/shield/stripe_downleft.png"
    },
    ss: {
        name: "Paly",
        bannerImage: "/patterns/banner/small_stripes.png",
        shieldImage: "/patterns/shield/small_stripes.png"
    },
    cr: {
        name: "Saltire",
        bannerImage: "/patterns/banner/cross.png",
        shieldImage: "/patterns/shield/cross.png"
    },
    sc: {
        name: "Cross",
        bannerImage: "/patterns/banner/straight_cross.png",
        shieldImage: "/patterns/shield/straight_cross.png"
    },
    ld: {
        name: "Per Bend Sinister",
        bannerImage: "/patterns/banner/diagonal_left.png",
        shieldImage: "/patterns/shield/diagonal_left.png"
    },
    rud: {
        name: "Per Bend",
        bannerImage: "/patterns/banner/diagonal_right.png",
        shieldImage: "/patterns/shield/diagonal_right.png"
    },
    lud: {
        name: "Per Bend Inverted",
        bannerImage: "/patterns/banner/diagonal_up_left.png",
        shieldImage: "/patterns/shield/diagonal_up_left.png"
    },
    rd: {
        name: "Per Bend Sinister Inverted",
        bannerImage: "/patterns/banner/diagonal_up_right.png",
        shieldImage: "/patterns/shield/diagonal_up_right.png"
    },
    vh: {
        name: "Per Pale",
        bannerImage: "/patterns/banner/half_vertical.png",
        shieldImage: "/patterns/shield/half_vertical.png"
    },
    vhr: {
        name: "Per Pale Inverted",
        bannerImage: "/patterns/banner/half_vertical_right.png",
        shieldImage: "/patterns/shield/half_vertical_right.png"
    },
    hh: {
        name: "Per Fess",
        bannerImage: "/patterns/banner/half_horizontal.png",
        shieldImage: "/patterns/shield/half_horizontal.png"
    },
    hhb: {
        name: "Per Fess Inverted",
        bannerImage: "/patterns/banner/half_horizontal_bottom.png",
        shieldImage: "/patterns/shield/half_horizontal_bottom.png"
    },
    bl: {
        name: "Base Dexter canton",
        bannerImage: "/patterns/banner/square_bottom_left.png",
        shieldImage: "/patterns/shield/square_bottom_left.png"
    },
    br: {
        name: "Base Sinister canton",
        bannerImage: "/patterns/banner/square_bottom_right.png",
        shieldImage: "/patterns/shield/square_bottom_right.png"
    },
    tl: {
        name: "Chief Dexter canton",
        bannerImage: "/patterns/banner/square_top_left.png",
        shieldImage: "/patterns/shield/square_top_left.png"
    },
    tr: {
        name: "Chief Sinister canton",
        bannerImage: "/patterns/banner/square_top_right.png",
        shieldImage: "/patterns/shield/square_top_right.png"

    },
    bt: {
        name: "Chevron",
        bannerImage: "/patterns/banner/triangle_bottom.png",
        shieldImage: "/patterns/shield/triangle_bottom.png"
    },
    tt: {
        name: "Inverted chevron",
        bannerImage: "/patterns/banner/triangle_top.png",
        shieldImage: "/patterns/shield/triangle_top.png"
    },
    bts: {
        name: "Base Indented",
        bannerImage: "/patterns/banner/triangles_bottom.png",
        shieldImage: "/patterns/shield/triangles_bottom.png"
    },
    tts: {
        name: "Chief Indented",
        bannerImage: "/patterns/banner/triangles_top.png",
        shieldImage: "/patterns/shield/triangles_top.png"
    },
    mc: {
        name: "Roundel",
        bannerImage: "/patterns/banner/circle.png",
        shieldImage: "/patterns/shield/circle.png"
    },
    mr: {
        name: "Lozenge",
        bannerImage: "/patterns/banner/rhombus.png",
        shieldImage: "/patterns/shield/rhombus.png"
    },
    bo: {
        name: "Bordure",
        bannerImage: "/patterns/banner/border.png",
        shieldImage: "/patterns/shield/border.png"
    },
    cbo: {
        name: "Bordure Indented",
        bannerImage: "/patterns/banner/curly_border.png",
        shieldImage: "/patterns/shield/curly_border.png"
    },
    bri: {
        name: "Field Masoned",
        bannerImage: "/patterns/banner/bricks.png",
        shieldImage: "/patterns/shield/bricks.png"
    },
    gra: {
        name: "Gradient",
        bannerImage: "/patterns/banner/gradient.png",
        shieldImage: "/patterns/shield/gradient.png"
    },
    gru: {
        name: "Base gradient",
        bannerImage: "/patterns/banner/gradient_up.png",
        shieldImage: "/patterns/shield/gradient_up.png"
    },
    cre: {
        name: "Creeper Charge",
        bannerImage: "/patterns/banner/creeper.png",
        shieldImage: "/patterns/shield/creeper.png"
    },
    sku: {
        name: "Skull Charge",
        bannerImage: "/patterns/banner/skull.png",
        shieldImage: "/patterns/shield/skull.png"
    },
    flo: {
        name: "Flower Charge",
        bannerImage: "/patterns/banner/flower.png",
        shieldImage: "/patterns/shield/flower.png"
    },
    moj: {
        name: "Thing",
        bannerImage: "/patterns/banner/mojang.png",
        shieldImage: "/patterns/shield/mojang.png"
    },
    glb: {
        name: "Globe",
        bannerImage: "/patterns/banner/globe.png",
        shieldImage: "/patterns/shield/globe.png"
    },
    pig: {
        name: "Piglin Charge",
        bannerImage: "/patterns/banner/piglin.png",
        shieldImage: "/patterns/shield/piglin.png"
    }

}

export const colors = [
    { id: 0, name: "White", rgb: 16383998, rainbow: 0 },
    { id: 1, name: "Orange", rgb: 16351261, rainbow: 5 },
    { id: 2, name: "Magenta", rgb: 13061821, rainbow: 13 },
    { id: 3, name: "Light Blue", rgb: 3847130, rainbow: 10 },
    { id: 4, name: "Yellow", rgb: 16701501, rainbow: 6 },
    { id: 5, name: "Lime", rgb: 8439583, rainbow: 7 },
    { id: 6, name: "Pink", rgb: 15961002, rainbow: 14 },
    { id: 7, name: "Gray", rgb: 4673362, rainbow: 2 },
    { id: 8, name: "Light Gray", rgb: 10329495, rainbow: 1 },
    { id: 9, name: "Cyan", rgb: 1481884, rainbow: 9 },
    { id: 10, name: "Purple", rgb: 8991416, rainbow: 12 },
    { id: 11, name: "Blue", rgb: 3949738, rainbow: 11 },
    { id: 12, name: "Brown", rgb: 8606770, rainbow: 15 },
    { id: 13, name: "Green", rgb: 6192150, rainbow: 8 },
    { id: 14, name: "Red", rgb: 11546150, rainbow: 4 },
    { id: 15, name: "Black", rgb: 1908001, rainbow: 3 }
]

export const baseBanners = [
    {
        name: "White Banner",
        id: "white_banner"
    },
    {
        name: "Orange Banner",
        id: "orange_banner"
    },
    {
        name: "Magenta Banner",
        id: "magenta_banner"
    },
    {
        name: "Light_blue Banner",
        id: "light_blue_banner"
    },
    {
        name: "Yellow Banner",
        id: "yellow_banner"
    },
    {
        name: "Lime Banner",
        id: "lime_banner"
    },
    {
        name: "Pink Banner",
        id: "pink_banner"
    },
    {
        name: "Gray Banner",
        id: "gray_banner"
    },
    {
        name: "Light_gray Banner",
        id: "light_gray_banner"
    },
    {
        name: "Cyan Banner",
        id: "cyan_banner"
    },
    {
        name: "Purple Banner",
        id: "purple_banner"
    },
    {
        name: "Blue Banner",
        id: "blue_banner"
    },
    {
        name: "Brown Banner",
        id: "brown_banner"
    },
    {
        name: "Green Banner",
        id: "green_banner"
    },
    {
        name: "Red Banner",
        id: "red_banner"
    },
    {
        name: "Black Banner",
        id: "black_banner"
    }]



